import {useSelector} from "react-redux";
import {NavLink} from "react-router-dom";

import {selectIsSuperUser} from "../../../slices/UserSlice";
import useLocationPermission from "../../adminForms/Ba3aSettings/tabs/PositionsSettings/useLocationPermission";

const MyLink = props => {
  const {onlyForSU} = props;

  const isSuperUser = useSelector(selectIsSuperUser);

  const {isNotAllowed} = useLocationPermission({location: props.to});

  let activeStyle = {
    fontWeight: 600,
  };

  const notAvailableStyle = {
    color: "#7f95b4",
    fontWeight: 400,
  };

  return isNotAllowed || (onlyForSU && !isSuperUser) ? null : (
    <span
      style={{
        display: "flex",
        gap: "2px",
        justifyContent: "flex-start",
        padding: "0 8px 2px 8px",
      }}
      className="nav-item fGrow"
    >
      <NavLink
        className="fGrow"
        end
        to={props.to}
        style={({isActive}) => {
          if (props.notAvailableStyle || isNotAllowed) {
            return notAvailableStyle;
          }

          return isActive ? props.style || activeStyle : undefined;
        }}
      >
        {props.name}
      </NavLink>
    </span>
  );
};

export default MyLink;
